import api from '../../../services/api';

/**
 * Fetch audit logs for an RFP
 */
export const fetchAuditLogs = async (rfpId) => {
    return api.get(`/audit/rfp/${rfpId}/view`);
};

/**
 * Download audit logs for an RFP
 */
export const downloadAuditLogs = async (rfpId, userTimezone) => {
    return api.get(`/audit/rfp/${rfpId}/download?timezone=${encodeURIComponent(userTimezone)}`, {
        responseType: 'blob'
    });
};
